var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { DOMAIN_CONNECT_PROVIDERS, TEMPLATE_LOOKUP, } from '@/types';
import { getRootDomainIP, getSubDomainUrl } from '@/utility';
import { inject, ref } from 'vue';
import { DomainConnectServices } from '@/service/DomainConnectService';
import { EmailService } from '@/service/EmailService';
export const useRecord = () => {
    var _a, _b, _c, _d, _e;
    const route = inject('route');
    const store = inject('store');
    const isProcessing = ref(false);
    const authorizeUrl = ref();
    const recordTableData = ref([]);
    const locationId = (_a = route === null || route === void 0 ? void 0 : route.params) === null || _a === void 0 ? void 0 : _a.location_id;
    const companyId = (_e = (_d = (_c = (_b = store === null || store === void 0 ? void 0 : store.state) === null || _b === void 0 ? void 0 : _b.company) === null || _c === void 0 ? void 0 : _c.company) === null || _d === void 0 ? void 0 : _d.id) !== null && _e !== void 0 ? _e : '';
    const fetchEmailRecord = (payload) => __awaiter(void 0, void 0, void 0, function* () {
        var _f, _g;
        try {
            const domain = payload.subDomainValue
                ? `${payload.subDomainValue}.${payload.domain}`
                : payload.domain;
            const { data } = yield EmailService.getEmailISVDomainRecords({
                domain,
                locationId,
                companyId: locationId ? undefined : companyId,
            });
            recordTableData.value = [
                ...((_f = data === null || data === void 0 ? void 0 : data.sendingDnsRecords) !== null && _f !== void 0 ? _f : []),
                ...((_g = data === null || data === void 0 ? void 0 : data.receivingDnsRecords) !== null && _g !== void 0 ? _g : []),
            ].map(record => {
                var _a, _b, _c;
                return ({
                    record: (_a = record === null || record === void 0 ? void 0 : record.recordType) !== null && _a !== void 0 ? _a : '',
                    host: (_b = record === null || record === void 0 ? void 0 : record.host) !== null && _b !== void 0 ? _b : '',
                    value: (_c = record === null || record === void 0 ? void 0 : record.value) !== null && _c !== void 0 ? _c : '',
                });
            });
        }
        catch (err) {
            recordTableData.value = [];
            console.error(err);
        }
    });
    const getEmailPayload = (payload) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        const mxArray = (_a = recordTableData.value) === null || _a === void 0 ? void 0 : _a.filter(entry => (entry === null || entry === void 0 ? void 0 : entry.record) === 'MX');
        const txtArray = (_b = recordTableData.value) === null || _b === void 0 ? void 0 : _b.filter(entry => (entry === null || entry === void 0 ? void 0 : entry.record) === 'TXT');
        const cnameObj = (_c = recordTableData.value) === null || _c === void 0 ? void 0 : _c.find(entry => (entry === null || entry === void 0 ? void 0 : entry.record) === 'CNAME');
        const cnameValue = (_d = cnameObj === null || cnameObj === void 0 ? void 0 : cnameObj.value) !== null && _d !== void 0 ? _d : '';
        const domain = payload.domain;
        const host = payload.subDomainValue ? payload.subDomainValue : undefined;
        let mxHost1 = '@';
        let mxHost2 = '@';
        const mxValue1 = (_f = (_e = mxArray === null || mxArray === void 0 ? void 0 : mxArray[0]) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '';
        const mxValue2 = (_h = (_g = mxArray === null || mxArray === void 0 ? void 0 : mxArray[1]) === null || _g === void 0 ? void 0 : _g.value) !== null && _h !== void 0 ? _h : '';
        const dynamicTXT = txtArray.find(record => record.host !== '@' && record.host !== host);
        const staticTXT = txtArray.find(record => record.host === '@' || record.host === host);
        let txtHost1 = (_j = dynamicTXT === null || dynamicTXT === void 0 ? void 0 : dynamicTXT.host) !== null && _j !== void 0 ? _j : '';
        const txtValue1 = (_k = dynamicTXT === null || dynamicTXT === void 0 ? void 0 : dynamicTXT.value) !== null && _k !== void 0 ? _k : '';
        const txtValue2 = (_l = staticTXT === null || staticTXT === void 0 ? void 0 : staticTXT.value) !== null && _l !== void 0 ? _l : '';
        // cloudflare handle txt record without suffixing host
        if (payload.provider === DOMAIN_CONNECT_PROVIDERS.CLOUDFLARE) {
            txtHost1 = (_m = dynamicTXT === null || dynamicTXT === void 0 ? void 0 : dynamicTXT.host) !== null && _m !== void 0 ? _m : '';
            if (host) {
                mxHost1 = host;
                mxHost2 = host;
            }
        }
        return {
            cnameValue,
            domain,
            host,
            mxHost1,
            mxHost2,
            mxValue1,
            mxValue2,
            txtHost1,
            txtValue1,
            txtValue2,
        };
    };
    const fetchAuthorizationUrl = (payload) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            if (payload.template === TEMPLATE_LOOKUP.aCname) {
                const { data } = yield DomainConnectServices.initDomainConnectRootDomainAndCNameRecord({
                    cnameValue: getSubDomainUrl(payload.team),
                    domain: payload.domain,
                    IP: getRootDomainIP(payload.team),
                });
                authorizeUrl.value = data.ok.href;
            }
            else if (payload.template === TEMPLATE_LOOKUP.a) {
                const { data } = yield DomainConnectServices.initDomainConnectRootDomain({
                    domain: payload.domain,
                    IP: getRootDomainIP(payload.team),
                });
                authorizeUrl.value = data.ok.href;
            }
            else if (payload.template === TEMPLATE_LOOKUP.cname) {
                const { data } = yield DomainConnectServices.initDomainConnectCname({
                    cnameValue: getSubDomainUrl(payload.team),
                    domain: payload.domain,
                    host: payload.subDomainValue,
                });
                authorizeUrl.value = data.ok.href;
            }
            else if (payload.template === TEMPLATE_LOOKUP.email) {
                // Entries to be filled by the email team
                const { data } = yield DomainConnectServices.initDomainConnectEmail(getEmailPayload({
                    domain: payload.domain,
                    provider: payload.provider,
                    subDomainValue: payload.subDomainValue,
                }));
                authorizeUrl.value = data.ok.href;
            }
            else if (payload.template === TEMPLATE_LOOKUP.aTxtSsl) {
                // Entries to be filled by the wordpress team
            }
        }
        catch (err) {
            authorizeUrl.value = undefined;
            console.error('Error getting Records');
        }
    });
    const addRecords = (payload) => __awaiter(void 0, void 0, void 0, function* () {
        isProcessing.value = true;
        if (payload.template === TEMPLATE_LOOKUP.email) {
            // Entries to be filled by the email team
            yield fetchEmailRecord({
                domain: payload.domain,
                subDomainValue: payload.subDomainValue,
            });
        }
        else if (payload.template === TEMPLATE_LOOKUP.aTxtSsl) {
            // Entries to be filled by the wordpress team
        }
        else if (payload.template === TEMPLATE_LOOKUP.aCname) {
            recordTableData.value.push({
                record: 'A',
                host: '@',
                value: getRootDomainIP(payload.team),
            });
            recordTableData.value.push({
                record: 'CNAME',
                host: 'www',
                value: getSubDomainUrl(payload.team),
            });
        }
        else if (payload.template === TEMPLATE_LOOKUP.a) {
            recordTableData.value.push({
                record: 'A',
                host: '@',
                value: getRootDomainIP(payload.team),
            });
        }
        else if (payload.template === TEMPLATE_LOOKUP.cname) {
            recordTableData.value.push({
                record: 'CNAME',
                host: payload.subDomainValue,
                value: getSubDomainUrl(payload.team),
            });
        }
        isProcessing.value = false;
    });
    const resetRecords = () => {
        recordTableData.value = [];
        authorizeUrl.value = undefined;
    };
    return {
        recordTableData,
        addRecords,
        resetRecords,
        fetchAuthorizationUrl,
        authorizeUrl,
        isProcessing,
    };
};
